module.exports = "/_next/static/images/nail-it-logo-bc93cf553e634b1f640cbbcad2c38462.svg";